export type FormNameType = 'contact' | 'footer' | 'restaurant-contact';

export interface FormFieldType {
  type: string;
  name: string;
  label: string;
  placeholder: string;
  required: boolean;
  autocomplete: string;
}

export const CONTACT_FIELDS: FormFieldType[] = [
  {
    type: 'text',
    name: 'name',
    label: 'Name',
    placeholder: 'Name',
    required: true,
    autocomplete: 'name',
  },
  {
    type: 'email',
    name: 'email',
    label: 'Email',
    placeholder: 'Email',
    required: true,
    autocomplete: 'email',
  },
  {
    type: 'text',
    name: 'subject',
    label: 'Subject',
    placeholder: 'Subject',
    required: true,
    autocomplete: 'off',
  },
  {
    type: 'textarea',
    name: 'message',
    label: 'Message',
    placeholder: 'Your Message',
    required: true,
    autocomplete: 'off',
  },
];

export const FOOTER_FIELDS: FormFieldType[] = [
  {
    type: 'email',
    name: 'email',
    label: 'Email Address',
    placeholder: 'Enter your email',
    required: true,
    autocomplete: 'email',
  },
];

export const RESTAURANT_FIELDS: FormFieldType[] = [
  {
    name: 'restaurantName',
    label: 'Restaurant Name',
    placeholder: 'Restaurant Name',
    type: 'text',
    required: true,
    autocomplete: 'organization',
  },
  {
    name: 'ownerName',
    label: 'Your Name',
    placeholder: 'Your Name',
    type: 'text',
    required: true,
    autocomplete: 'name',
  },
  {
    name: 'email',
    label: 'Email Address',
    placeholder: 'Email Address',
    type: 'email',
    required: true,
    autocomplete: 'email',
  },
  {
    name: 'phone',
    label: 'Phone Number',
    placeholder: 'Phone Number (optional)',
    type: 'tel',
    required: false,
    autocomplete: 'tel',
  },
  {
    name: 'currentWebsite',
    label: 'Current Website',
    placeholder: 'Current Website (if you have one)',
    type: 'url',
    required: false,
    autocomplete: 'url',
  },
  {
    name: 'message',
    label: 'Tell us about your needs',
    placeholder:
      'What would you like help with? (e.g., new website, online ordering, menu updates)',
    type: 'textarea',
    required: true,
    autocomplete: 'off',
  },
];
